import ResetPasswordApply from "./reset-password-apply"

export default ResetPasswordApply
